import { render } from "./headerComp.vue?vue&type=template&id=4b0d3c96&scoped=true&ts=true"
import script from "./headerComp.vue?vue&type=script&lang=ts"
export * from "./headerComp.vue?vue&type=script&lang=ts"

import "./headerComp.vue?vue&type=style&index=0&id=4b0d3c96&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0d3c96"]])

export default __exports__